import { render, staticRenderFns } from "./SpeechDetails.vue?vue&type=template&id=43752d30"
import script from "./SpeechDetails.vue?vue&type=script&lang=js"
export * from "./SpeechDetails.vue?vue&type=script&lang=js"
import style0 from "./SpeechDetails.vue?vue&type=style&index=0&id=43752d30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports